var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('gr-loading',{attrs:{"data-test-name":"gr-loading-create-trend-from-template"}},[_vm._v(" Creating"),_c('br'),_vm._v("trend ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }